import { object, string } from 'yup'

export const productOriginTechnicalValidationSchema = object({
  origin: string().trim().required('El campo Origen del producto es obligatorio.'),
  name: string().trim().required('El campo Nombre Marca en WMS es obligatorio.')
})
